import { createSlice } from '@reduxjs/toolkit';

import { addNewPost, markNewPost, removeNewPosts } from './actions';
import { initialState } from './state';

export const newPostsSlice = createSlice({
  name: 'newPosts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(addNewPost, (state, { payload }) => {
      state.posts = [payload, ...state.posts];
    });
    builder.addCase(markNewPost, (state, { payload }) => {
      state.markedNewPostIds = [payload, ...state.markedNewPostIds];
    });
    builder.addCase(removeNewPosts, state => {
      state.markedNewPostIds = [];
      state.posts = [];
    });
  },
});
